import PageBreadcrumb from "../../components/common/PageBreadCrumb";
import PageMeta from "../../components/common/PageMeta";
import { useEffect, useState } from "react";
import Spinner from "../../components/ui/Spinner";
import {
  API_BASE_URL,
  API_URL,
  DEFAULT_PAGE_DESCRIPTION,
  DEFAULT_PAGE_TITLE,
  DEFAULT_PER_PAGE,
} from "../../utilities/constants";
import { NavLink, useLocation, useNavigate } from "react-router";
import Pagination from "../../components/ui/Pagination";
import useQueryParams from "../../hooks/useQueryParams";
import { handleApiCall, jsonToQueryParams } from "../../utilities/helper";
import { useUI } from "../../context/UI";
import TableFilter from "./TableFilter";
import ButtonText from "../../components/ui/button/ButtonText";

const EventsPage = () => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(false);
  const navigate = useNavigate();
  const { queryParams } = useQueryParams();
  const pageNo = queryParams.get("pageNo") || 0;
  const pageSize = queryParams.get("pageSize") || DEFAULT_PER_PAGE;
  const sortOrder = queryParams.get("sortOrder") || "DESC";
  const location = useLocation();
  const {
    setSegmentTitle,
  } = useUI();
  const [controller, setController] = useState(null);

  const callListApi = async () => {
    controller?.abort();
    const newController = new AbortController();
    setController(newController);
    const { signal } = newController;
    setLoading(true);
    try {
      const query = jsonToQueryParams({
        keyword: queryParams.get("search") || "",
      });
      const response = await handleApiCall(
        `${API_BASE_URL}/api/1.0.0/styleevent/events?pageNo=${pageNo}&pageSize=${pageSize}&sortBy=createdAt&direction=${sortOrder}&${query}`,
        {
          method: "GET"
        },
        null,
        signal
      );
      if (response.responseStatus == true) {
        setData(response.data);
      } else {
        setData(null);
      }
      if (response.responseCode !== 299) {
        setLoading(false);
      }
    } catch (e) {
      console.error("Error", e);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    callListApi();
    setSegmentTitle("User");
  }, [location.search]);

  return (
    <>
      <PageMeta
        title={`Events - ${DEFAULT_PAGE_TITLE}`}
        description={`Events - ${DEFAULT_PAGE_DESCRIPTION}`}
      />

      <div className="flex justify-between items-center mb-1">
        <PageBreadcrumb pageTitle="Events" />
      </div>
      <div className="flex justify-between items-center mb-6">
        <TableFilter />
        <ButtonText
          title='+ Add New'
          onClick={() => { navigate('/add-event') }}
        />
      </div>
      {loading ? (
        <div className="flex justify-center items-center">
          <Spinner />
        </div>
      ) : (
        <div className="space-y-6">
          <div className="relative overflow-x-auto sm:rounded-lg">
            <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400 rounded-lg">
              <thead className="text-xs text-gray-700 uppercase bg-gray-100 dark:bg-gray-700 dark:text-gray-400">
                <tr>
                  <th scope="col" className="px-6 py-3"> Name</th>
                  <th scope="col" className="px-6 py-3"> Description</th>
                  <th scope="col" className="px-6 py-3"> Tags</th>
                  <th scope="col" className="px-6 py-3"> Action</th>
                </tr>
              </thead>
              <tbody>
                {data?.map((user, index) => (
                  <tr key={index} className="border-b dark:border-gray-600 text-sm text-gray-700 dark:text-gray-300">
                    <td className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white">{user.eventName || "-"}</td>
                    <td className="px-6 py-4">{user.description || "-"}</td>
                    <td className="px-6 py-4">{user.description || "-"}</td>
                    <td className="px-6 py-4 flex gap-5">
                      <NavLink
                        to={`/events-details/${user?.id}`}
                        state={{ user: user }}
                      >
                        <button
                          type="button"
                          className="bg-yellow-600 text-white px-6 py-2 rounded-md hover:bg-yellow-700 transition"
                        >
                          View
                        </button>
                      </NavLink>
                      <NavLink to={`/edit-event/${user?.id}`} state={{ user: user }}>
                        <button
                          type="submit"
                          className="edit-button"
                        >
                          Edit
                        </button>
                      </NavLink>
                    </td>

                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      <div className='flex justify-center items-center'>
        <Pagination
          currentPage={data?.pageNumber + 1} 
          totalElements={data?.totalElements}
        />
      </div>
    </>
  );
};

export default EventsPage;
